import { getToken } from "../../../common/environment_config.es6";

// Galerideki "Aidea Avatar Kütüphanesi" kartlarından yalnızca organizasyona ait
// (kullanıcının kaydettiği) aidea avatarları silinebilir. Global/sistem avatarlarında
// metadata.organizationId yoktur → çöp kutusu gösterilmez (backend de 403 döner).
export const isDeletableAvatar = (avatar) =>
  !!avatar && avatar.providerType === "aidea" && !!avatar.metadata?.organizationId;

// DELETE api/talking-avatar/avatars/:id
//   200 → { status: "deleted" }
//   404 → { status: "gone" }   (yok / zaten silinmiş / başka org — listeden de düş)
//   diğer → { status: "error", code } (AVATAR_ID_INVALID, AVATAR_NOT_DELETABLE,
//           AVATAR_DELETE_FAILED → avatar silinMEDİ) — ağ hatasında code null.
export async function deleteSavedAvatar(avatarId) {
  try {
    const response = await fetch(
      `${process.env.MW_API_URL}api/talking-avatar/avatars/${encodeURIComponent(avatarId)}`,
      {
        method: "DELETE",
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    if (response.ok) return { status: "deleted" };
    let body = null;
    try {
      body = await response.json();
    } catch (e) {
      body = null;
    }
    if (response.status === 404) return { status: "gone", code: body?.code || null };
    return { status: "error", code: body?.code || null, httpStatus: response.status };
  } catch (error) {
    console.error("Error deleting avatar:", error);
    return { status: "error", code: null };
  }
}
